export const tableProductsSold = {
	label: "Salida de productos en mesa",
	mainTitle: "Desempeño de las mesas",
	mainSubtitle:
		"Monitoree el desempeño de las mesas y potencie la gestión de su restaurante.",
	tabName: "Desempeño de las mesas",
	title: "Salida de productos en mesa",
	filters: {
		table: "Mesa",
		employeeName: "Mesero",
		payment: "Pago",
		product: "Producto",
		tablePlaceholder: "Seleccione una mesa",
		employeeNamePlaceholder: "Todos",
		status: "Estado",
		dateOrPeriod: "Fecha o período",
		paymentPlaceholder: "Todos",
		productPlaceholder: "Todos",
	},
	table: {
		title: "Consumo de mesas",
		columns: {
			tableName: "MESA",
			employeeName: "MESERO",
			numberOfSeats: "PERSONAS",
			openedAt: "APERTURA",
			permanence: "PERMANENCIA",
			tip: "SERVICIO",
			productsValue: "PRODUCTOS",
			closedAt: "CIERRE",
			discount: "DESCUENTOS",
			refundValue: "REEMBOLSOS",
			totalValue: "TOTAL",
			products: {
				imageUrl: "FOTO",
				sku: "SKU",
				name: "NOMBRE DEL PRODUCTO",
				quantity: "CANTIDAD",
				unitPrice: "VALOR UNITARIO",
				subTotal: "SUBTOTAL",
				discount: "DESCUENTOS",
				total: "VALOR TOTAL",
			},
		},
	},
};
